<template>
    <v-dialog v-model="showDialog_CommanderDecisions" width="650" persistent>
        <v-card>
            <v-card-title class="blue-grey pa-5" style="color: white; font-size: 15px;  font-weight: 500;">
                <i style="font-size:20px;" class="b-fa b-fa-hat-cowboy"></i>&nbsp;&nbsp;Select/Modify Extended or Commander Decision
            </v-card-title>

            <v-card-text>
                <v-container fluid>
                    <v-row>
                        <v-col cols="12">
                            <!-- >>> Extended ------------------------------ -->
                            <p class="pb-2" style="font-size:13px; font-weight: 500;">Please select a Person for Extended:</p>
                            <v-select
                                v-model="select"
                                :items="get_flights_CrewDetails_Reduced"
                                item-text="filterableName"
                                item-value="idResource"
                                label="Extended Decision"
                                outlined
                                dense
                                chips
                                multiple
                            ></v-select>

                            <!-- >>> Commander  ---------------------------- -->
                            <p class="pt-2 pb-2" style="font-size:13px; font-weight: 500;">Please select a Person for Commander Decision:</p>
                            <v-select
                                v-model="select2"
                                :items="get_flights_CrewDetails_Reduced"
                                item-text="filterableName"
                                item-value="idResource"
                                label="Commander Decision"
                                outlined
                                dense
                                chips
                                multiple
                            ></v-select>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
                <div class="flex-grow-1"></div>
                <v-btn style="width:120px; font-size:12px;" depressed elevation="1" outlined color="#ab3b7a" @click="onCancel_CommanderDecisions">Cancel</v-btn>
                <v-btn style="width:120px; font-size:12px;" depressed elevation="1" color="primary" @click="onSave_CommanderDecisions">Save</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    import Vue from 'vue';
    import { mapActions } from 'vuex';
    import { mapGetters } from 'vuex';


    export default {
        name : 'Dialog_CommanderDecisions',

        /* >>> *************************************************************** / /* Props */
        props : {
            value: [ Boolean, Object ], // showDialog_CommanderDecisions
        },
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Watch */
        watch: {

            /*******************************************************************
            * watch::get_flights_CrewDetails_Reduced
            *
            * Desc: Monitor/Watch ... 'get_flights_CrewDetails_Reduced'.
            * Note: Set preselected Values.
            *
            */
            get_flights_CrewDetails_Reduced(v) {

                let me = this;


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/crewdetails/dialogs/Dialog_CommanderDecisions.vue >>> watch/get_flights_CrewDetails_Reduced');
                // >>> Prefill/Preset -------------------------
                this.get_flights_CrewDetails_Reduced.forEach(member => {
                    if (member.manualStatus === 'E') {
                        if (!this.select.includes(member.idResource)) {
                            this.select.push(member.idResource);
                        }
                    }
                    if (member.manualStatus === 'C') {
                        if (!this.select2.includes(member.idResource)) {
                            this.select2.push(member.idResource);
                        }
                    }

                });

            }, // eo function get_flights_CrewDetails_Reduced()

        }, // eo watch{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([
                'get_flights_CrewDetails_Reduced',
                'get_flights_CrewDetails_SavedPayload', // getting 'idFlightGroup'
            ]),


            /*******************************************************************
            * showDialog_CommanderDecisions()
            *
            * Desc:
            * Note:
            *
            */
            showDialog_CommanderDecisions: {

                /***************************************************************
                * get()
                *
                * Note:.
                *
                */
                get() {

                    let me = this;


                    me.$toc('>>> views/crewplanning/crewplanning/components/calendar/crewdetails/dialoags/Dialog_CommanderDecisions.vue >>> showDialog_CommanderDecisions get');
                    // return always Boolean
                    return !!this.value;

                }, // eo showDialog_CommanderDecisions get()


                /***************************************************************
                * set()
                *
                * Desc:
                * Note: only runs on close.
                *
                */
                set(value) {

                    let me = this;;


                    me.$toc('>>> views/crewplanning/crewplanning/components/calendar/crewdetails/dialoags/Dialog_CommanderDecisions.vue >>> showDialog_CommanderDecisions set');
                    this.$emit('input', value);

                } // eo showDialog_CommanderDecisions set()

            } // eo function showDialog_CommanderDecisions()

        }, // eo computed{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Data */
        data() {

            return {
                select: [], // extended decision
                select2: [], // commander decision
            };

        }, // eo data()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Methods */
        methods: {

            ...mapActions([
                'actn_call_crews_setCommanderExtendedDecision',
                'actn_call_getCrewDetailsFromFlight_Reduced'
            ]),


            /*******************************************************************
            * onSave_CommanderDecisions()
            *
            * Desc:
            * Note: 'C'= Commander, 'E'=Extended
            * Note:
            *
            */
            onSave_CommanderDecisions: function() {

                let me = this,
                    isDouble = false,
                    params = {},
                    get_flights_CrewDetails_Reduced_Copy = [...this.get_flights_CrewDetails_Reduced];


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/crewdetails/dialogs/Dialog_CommanderDecisions.vue >>> onSave_CommanderDecisions');
                // >>> ------------------------------------ Filter(s) Functions
                const filterSelected = (member) => {
                    let applyFilter = true; // true => stay, false=>out

                    if (this.select.length > 0) {
                        if (this.select.includes(member.idResource)) {
                            applyFilter = false;
                        }
                    } else {
                        applyFilter = true;
                    }

                    return applyFilter;
                };

                const filterSelected2 = (member) => {
                    let applyFilter = true; // true => stay, false=>out

                    if (this.select2.length > 0) {
                        if (this.select2.includes(member.idResource)) {
                            applyFilter = false;
                        }
                    } else {
                        applyFilter = true;
                    }

                    return applyFilter;
                };
                // <<< ------------------------------------


                // >>> ------------------------------------ Protector(s) #566
                if (this.select.length > 0 && this.select2.length > 0 ) {
                    this.select.forEach(el => {
                        if (this.select2.includes(el)) {
                            isDouble = true;
                        }
                    });

                    if (isDouble) {
                        Vue.prototype.$toasted.global.sdr_app_info({
                            message: 'Attention: Dear User, same Member for both Functions.'
                        });
                        return;
                    }
                }



                // >>> ------------------------------------ Null/Reset/Delete Calls
                Vue.prototype.$vp_m();

                get_flights_CrewDetails_Reduced_Copy = get_flights_CrewDetails_Reduced_Copy.filter(member => filterSelected(member));
                get_flights_CrewDetails_Reduced_Copy = get_flights_CrewDetails_Reduced_Copy.filter(member => filterSelected2(member));
                this.get_flights_CrewDetails_Reduced.forEach(member => {
                    params = {
                        idFlightGroup: this.get_flights_CrewDetails_SavedPayload.idFlightGroup,
                        idResources: [member.idResource],
                        manualStatus: null, // null, C, E
                    };
                    this.actn_call_crews_setCommanderExtendedDecision(params);
                });


                // >>> ------------------------------------ Extended Call
                if (this.select.length > 0) {
                    params = {
                        idFlightGroup: this.get_flights_CrewDetails_SavedPayload.idFlightGroup,
                        idResources: this.select,
                        manualStatus: 'E',
                    };
                    this.actn_call_crews_setCommanderExtendedDecision(params);
                }


                // >>> ------------------------------------ Commander Decision Call
                if (this.select2.length > 0) {
                    params = {
                        idFlightGroup: this.get_flights_CrewDetails_SavedPayload.idFlightGroup,
                        idResources:  this.select2,
                        manualStatus: 'C',
                    };
                    this.actn_call_crews_setCommanderExtendedDecision(params);
                }


                // >>> ------------------------------------ Close/Reset/Reload
                setTimeout(() => {
                    Vue.prototype.$vp_um();
                    this.showDialog_CommanderDecisions = false;
                    this.actn_call_getCrewDetailsFromFlight_Reduced({ idFlight: this.get_flights_CrewDetails_SavedPayload.idFlightGroup })
                }, 700);

            }, // eo function onSave_CommanderDecisions()


            /*******************************************************************
            * onCancel_CommanderDecisions()
            *
            * Desc:
            * Note:
            *
            */
            onCancel_CommanderDecisions: function() {

                let me = this;


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/crewdetails/dialogs/Dialog_CommanderDecisions.vue >>> onCancel_CommanderDecisions');
                this.showDialog_CommanderDecisions = false; // close

                this.select = []; // extended decision reset
                this.select2 = []; // commander decision reset

                // >>> Prefill/Preset -------------------------
                this.get_flights_CrewDetails_Reduced.forEach(member => {

                    if (member.manualStatus === 'E') {
                        if (!this.select.includes(member.idResource)) {
                            this.select.push(member.idResource);
                        }
                    }
                    if (member.manualStatus === 'C') {
                        if (!this.select2.includes(member.idResource)) {
                            this.select2.push(member.idResource);
                        }
                    }

                });

            }, // eo function onCancel_CommanderDecisions()

        } // eo methods{}
        /* <<< ****************************************************************/

    };
</script>

<style>
    .v-text-field.v-text-field--enclosed .v-text-field__details {
        margin-top: 4px !important;
    }
</style>
